import type { ExcursionPage } from "../slug-excursions";
import antibes from "@/assets/images/excursions/destinations/antibes.webp";

const page: ExcursionPage = {
  slug: "antibes-juan-les-pins",
  hero: {
    title: "Excursion Antibes – Juan-les-Pins",
    subtitle:
      "Vieilles pierres, remparts et plages iconiques au départ de Cannes.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: antibes,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Remparts, marché et vieille‑ville d'Antibes" },
      { text: "Juan‑les‑Pins : plages, pinède, ambiance chic" },
      { text: "Musée Picasso (selon ouverture)" },
      { text: "Cap d’Antibes et points de vue (option)" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Antibes",
        description: "Remparts, marché provençal, musée (optionnel).",
      },
      { title: "Juan‑les‑Pins", description: "Plages, port, promenade." },
      { title: "Cap d’Antibes (option)", description: "Belvédères et photos." },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "3 à 5 heures" },
      { label: "Départ", value: "Cannes" },
      { label: "Saison", value: "Toute l'année" },
      { label: "Option", value: "Musée / belvédères selon envie" },
    ],
  },
};

export default page;
